/** 改這一處即可調整全站 Table／DetailTable 預設字級（`sm`｜`base`）。 */
export const DEFAULT_TABLE_TEXT_SIZE = 'base';

export function tableTextSizeClassName(textSize = DEFAULT_TABLE_TEXT_SIZE) {
  return textSize === 'sm' ? 'text-sm' : 'text-base';
}
